import { isMobile } from "./utils.js";
import { Toast } from "./toast.js";
import { Spinner } from "./spinner.js";
import { TypingIntro } from "./typing.js";

let _minLoadingTimeFired = false
let _modelIsLoaded = false
let _typingDemo = new TypingIntro(document.getElementById("greeting-text"))

export class IntroSequencing {

    static begin() {
        Spinner.show();
        setTimeout(function minLoadingSpinnerTimer() {
            _minLoadingTimeFired = true;
            IntroSequencing._showContent()
        }, 2000);
    }

    static markModelsAsLoaded() {
        _modelIsLoaded = true;
        IntroSequencing._showContent();
    }

    static _showContent() {
        if (!_modelIsLoaded || !_minLoadingTimeFired) {
            // wait until both the models have loaded AND the timer
            // have fired before showing hiding the loading spinner
            return
        }
        Spinner.hide();

        var slideDashes = document.getElementById('slide-dashes');
        slideDashes.style.display = 'block'; // Make the element take up space
        requestAnimationFrame(function () {
            slideDashes.style.opacity = 1; // Start the fade-in
        });

        var slideArrow = document.getElementById('web-chrome');
        slideArrow.style.display = 'block'; // Make the element take up space
        requestAnimationFrame(function () {
            slideArrow.style.opacity = 1; // Start the fade-in
        });

        IntroSequencing._beginTyping();

        if (isMobile()) {
            IntroSequencing._disableArrows();
            Toast.showSimpleMessage("Swipe to navigate");
        } else {
            Toast.showSimpleMessage("Use arrow keys to navigate");
        }
    }

    static _beginTyping() {
        _typingDemo.startTyping();
    }

    static stopTypingCursor() {
        if (_typingDemo) {
            _typingDemo.stopCursorBlink();
        }
    }

    static _disableArrows() {
        const chrome = document.querySelectorAll('#web-chrome');
        chrome.forEach(function (e) {
            e.style.display = 'none';
        })
    }
}
